// extracted by mini-css-extract-plugin
module.exports = {"pane":"pane__2bZET","text":"text__3bHnt","button-wrapper":"button-wrapper__2P8tA"};